import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

export const servicesData = [
  {
    id: 1,
    title: "Business Setup & Closure Services",
    desc: `BUSINESS SET UP SERVICES
${"─".repeat(80)}

• Incorporation of Public and Private Limited Companies including Company limited by Shares or by guarantee
• Incorporation of Section 8 (Non-profit organisation)
• Incorporation of One Person Company (OPC)
• Registering of a wholly owned subsidiaries
• Conversion of existing business entities into Company/LLP
• Registration of Partnership Firm
• Registration of Branch Offices / Liaison Offices / Project Offices of Foreign Company in India
• Registration of Trust
• Establishment of entity in Free Trade Zone / SEZ

CLOSURE / EXIT OF BUSINESS ENTITY
${"─".repeat(80)}

• Amalgamation/Merger
• Winding up of Companies (Voluntary and Compulsory)
• Acting as Voluntary Liquidator in case of voluntary winding up
• Striking of name of the Company from Ministry of Corporate Affairs
• Closure of Branch Office/Liaison Offices/Project Offices
• Liaison for Winding up with office of Judicial and Quasi Judicial Authorities, including National Company Law Tribunal, Regional Director, Registrar of Companies and Official Liquidator.`
  },
  {
    id: 2,
    title: "Limited Liability Partnership",
    desc: `Limited Liability Partnership, popularly known as LLP, is a worldwide recognized form of business organization. Introduced in India by way of the Limited Liability Partnership Act 2009, LLP combines the advantages of both the Company and Partnership entities into a single form of organization. LLPs need only two (2) Designated Partners and an LLP Agreement to commence its business operations. The Compliances under the LLP Act are fewer than those of a Company form of Organisation and hence most suited to small and medium-sized Business Organisations. Young Entrepreneurs or First Generation Entrepreneurs prefer LLP to all other forms of organisation. We at NSA provide the following gamut of services pertaining to LLPs:

• Obtaining DIN and Digital signatures for Partners
• Seeking availability of desired Name of LLP
• Incorporation of Limited Liability Partnership (LLP) Firm
• Drafting and vetting of LLP Agreements
• Conversion of company or partnership firm into Limited Liability Partnership
• Annual Compliances and Filling of returns, statement of account etc
• Providing necessary guidance in Restructuring in LLP
• Executing process of Admission, Retirement / Resignation / Capital Restructuring and all other types of Restructuring in the LLP
• Advising and guiding on Taxation driven Restructuring in the LLP
• Providing Event based Services like changing Name of LLP, shifting Registered Office of LLP within or outside State etc
• Facilitating FDIs in LLP and making all related FEMA Compliances with Reserve Bank of India`
  },
  {
    id: 3,
    title: "Corporate Advisory & Compliances",
    desc: `The summary of our services pertaining to Compliances, which are broadly required for various types of Companies includes but not limited to:

• Executing process of Alterations, modifications and changes in names of Companies, objects, share capital, situation of registered office, amendments and alterations in the Memorandum of Association and Articles of Association
• Executing process of Allotment of Shares, consolidation/sub-division of shares, transfer and transmission of Shares, conversion of shares into stocks or warrants, issue of shares certificates, dematerialization of shares, forfeiture of shares etc.
• Executing statutory process of Changes with respect to Directorship including appointment, re-appointment, regularization, resignations, fixation and revisions of the remunerations to Directors, Managers, Company Secretary, Compliance officer, secretary in whole time practice, auditors, cost auditors etc.
• Convening process relating to conducting Board Meetings, General meetings including ensuring pre and post meeting statutory compliances
• Executing process of ensuring Procedural compliances with respect to induction and expulsion of members, variation in membership rights
• Preparation of annual reports and annual accounts including Balance Sheet, Profit and loss account, income and expenditure statement, auditors report, directors' reports, statement on corporate governance, obtaining compliance certificate, Preparation of directors/ chairman's statement etc.
• Executing process of creation, modification and satisfaction of charges and facilitating client to represent Ministry of Corporate Affairs for Registration of the same
• To help in Preparation of Dividend Policy and provide assistance for ascertainment, declaration and payment of interim and final dividend; management of unpaid and unclaimed dividend
• Maintenance of statutory registers as per the provisions of the Companies Act 2013
• Assist in executing Procedures and compliances related to making inter-company loans, investments, guarantees and providing of securities
• Providing Assistance for filing of the statutory Returns, documents with the Ministry of Corporate Affairs
• Assist in Drafting various Corporate documents viz. Memorandum of Association, Articles of Association, Agreements, Allotment Letter, contract of appointments, share certificates, debentures/bond certificates, proxies, dividend / interest / redemption warrants, fixed deposit receipts, share transfer documents, documents related to public offerings and listing, notices, resolutions and minutes of meetings
• Assist in executing Process for passing resolution through Postal Ballot
• Executing process for Compounding of various offences under Companies Act 2013
• Assist in Dematerialization/Rematerialization of securities
• Assist in Obtaining DIN / DSC (including PAN encrypted) for directors and professionals
• Liaison with offices of ROC / RD / CLB / MCA for obtaining various regulatory approvals
• Assist in making Application for Condonation of delay while submission of Statutory Returns
• Provide Support for Statutory Compliances to Shifting of books of accounts from one place to another place
• Providing opinion on Corporate Law related queries
• Filing of Annual audited financials in XBRL form
• Assist in executing Statutory Compliances to Shifting of Registered Office of the Company from One State to another or within the jurisdiction of One ROC to the another in the same state
• Develop and monitor system of ascertaining Related Party Transactions
• Any other matter related to working and administration of Company Law including any new developments.`
  },
  {
    id: 4,
    title: "Corporate & Financial Restructuring",
    desc: `Corporate and Financial restructuring is the process of redesigning one or more aspects of a Company. The process of reorganizing a Company may be implemented due to a number of different factors, such as positioning the Company to be more competitive, survive a currently adverse economic climate, or poise the corporation to move in an entirely new direction.

CORPORATE RESTRUCTURING
${"─".repeat(80)}
This Category of services includes but not limited to:

• Undertaking process of determining / structuring Corporate Governance Structure
• Corporate Restructuring in the nature of takeover, Mergers, De-mergers
• Undertaking post-merger related services
• Revival of defunct/sick Companies
• Variation of Class Rights
• Joint Venture and alliance
• Conversion of Companies from Private to Public, from Public to Private or from Companies into LLP
• Dissolution and Winding up of Companies
• Change in the management of the Company

FINANCIAL RESTRUCTURING
${"─".repeat(80)}
This Category of services includes but not limited to:

• Issuing and allotment of securities for cash / consideration other than cash carrying voting rights and/or differential voting rights
• Rights issue / Bonus Issue / Sweat Equity / Preferential Issue / Private Placement of securities
• Reclassification / consolidation / sub division / cancellation of share capital
• Employees Stock Option Scheme / Employees Stock Purchase Scheme
• Buy Back of Securities
• Reduction of share capital`
  },
  {
    id: 5,
    title: "Due Diligence",
    desc: `A Due Diligence is essential when Companies aim to enter into transactions like Mergers & Acquisitions, Takeovers or Amalgamations. Especially in case of cross border Merger & Amalgamation or Cross Cultural Alliance, Due Diligence is crucial before making any decision. Also when the Company wants to release IPOs or to issue Foreign Currency Convertible Bonds (FCCBs), Global Depository Receipts (GDRs), Due Diligence is the prime focus in order to ascertain compliance of various laws and regulations including Commercial Agreements. Due Diligence entails the specific scrutiny of the legal affairs of the target company with a view to uncover any legal risks and providing the buyer Company with extensive insights into the Company's legal affairs. We at Nilesh Shah & Associates mainly undertake audit and conduct Due Diligence in the event including (but not limited to):

• Data Room Creation for Due Diligence Audit - physical and virtual
• Due Diligence Audit - Secretarial compliances
• Handling documentation - pre and post funding / merger / acquisition / investment etc.
• Private Funding - Advisory and Assistance including drafting
• To undertake Due diligence of Corporate Compliances in terms of RBI Act before granting Loan / Financial Assistance by Bank or Financial Institutions. (Whether under Consortium Arrangement or not).`
  },
  {
    id: 6,
    title: "FEMA & RBI",
    desc: `This Category of services mainly includes but not limited to:

• Preparation and filing of Returns with the Reserve Bank of India on Allotment of Shares in the form of FC-GPR, Transfer of Shares from Resident to Non-Resident or vice versa in the Form of FC-TRS and return with respect to Foreign Assets and Liabilities etc.
• Registering and Closure of Branch, Liaison or Project office of a Foreign Company in India with the Reserve Bank of India as well as Department of Company Affairs etc.
• Compounding the Offences under various provisions of FEMA
• Preparation and filing of Returns with respect to Non-Banking Finance Company`
  },
  {
    id: 7,
    title: "Audit & Certification",
    desc: `SECRETARIAL AUDIT
${"─".repeat(80)}
Introduced by the Companies Act 2013, 'Secretarial Audit' is a process to check compliances made by the Company under Corporate Law & other laws, rules, regulations, procedures etc. It is a mechanism to monitor compliance with the requirements of stated laws and processes. Periodically inspecting the records of company gives exact information whether, and if so, to what extent Company has complied with the laws applicable to it. Secretarial Audit assures regulators, stakeholders and management of the Company that it has a disciplined approach to evaluate and improve effectiveness of risk management, control, and governance processes. We undertake Secretarial Audit of the following Companies:

• Media Companies
• Non-Banking Finance Companies
• Pharmaceuticals Companies
• Various Manufacturing Companies
• Merchant Banking Companies
• Debt Listed Companies
• Power Generation Companies etc.

OTHER AUDITS / CERTIFICATION / REPORTS
${"─".repeat(80)}

• Undertaking Corporate Governance Compliance Audit as required under SEBI (LODR)
• Undertaking Audit as required by SEBI under Depositories and Participants Regulation: a). Reconciliation of share Capital Audit; b). Share Transfer Audit.
• Undertaking specific audits to ensure compliance of the SEBI Takeover Code, SEBI Insider Trading Regulations, etc.
• Secretarial Compliance Certification
• Certificate for Preferential issue of Shares, Buy-back, FC-GPR etc.
• Verification of Secretarial Data and Annual Returns of listed Companies and Certification of the correctness and compliances of the contents by exhaustive audit of each provisions of the Companies Act
• Certification of E-Forms which are required to be filed with the Registrar of Companies through web portal of Ministry of Corporate of Affairs
• Other Miscellaneous Certificates that may be required to be issued under various other Acts like FEMA, Listing Obligation (Disclosure and Requirements) Regulations etc.
• Filing of Annual Return/Forms (including XBRL)
• Providing Inspection facility and Search and Status Report
• Scrutinizer Report with respect to General Meetings, Postal Ballot Meetings, Court Convened Meetings, etc.`
  },
  {
    id: 8,
    title: "SEBI & Listing Compliances",
    desc: `The summary of our services pertaining to Listing Compliances, which are broadly required for various types of Listed Companies includes but not limited to:

• Assistance in managing IPO / FPO
• Listing / Delisting / Relisting of Securities
• Registration of intermediaries with SEBI (Mutual Fund, Stock and Sub Brokers, Portfolio Managers, Venture Capital Funds, Merchant Bankers, FIIs and other intermediaries)
• Audits and certification under SEBI (LODR)
• Assistance in compliance with provisions of SEBI (LODR)
• Assistance in compliance with various Guidelines, Rules and Regulations issued by SEBI
• Liaison with office of Stock Exchanges
• Acting as Scrutinizer in the process of Postal Ballot, Court Convened Meetings, etc.
• Ensuring compliance of SEBI Takeover Code, SEBI Insider Trading Regulations, etc.
• Other allied services`
  },
  {
    id: 9,
    title: "Representation & Other Services",
    desc: `REPRESENTATION
${"─".repeat(80)}
We represent our clients before following Regulatory Authorities:

• Ministry of Corporate Affairs (MCA)
• Securities and Exchange Board of India (SEBI)
• Company Law Board (CLB)
• Central Government (CG)
• Official Liquidator (OL)
• National Company Law Tribunal (NCLT)
• Reserve Bank of India (RBI)
• Stock Exchanges (SE)
• Regional Director (RD)

OTHERS
${"─".repeat(80)}

• Providing Written Opinions
• Drafting Shareholder's Agreements and other Legal Documents
• Providing opinion on Corporate Law related queries
• Conversion of Financials of Company into machine-readable format to facilitate XBRL filings by the Corporate
• Providing services related to Intellectual Property Rights`
  },
];

export default function Services() {
  const location = useLocation();
  const [activeId, setActiveId] = useState(1);
  const [mobileActiveId, setMobileActiveId] = useState(null);

  const contentRef = React.useRef(null);
  const mobileContentRef = React.useRef(null);

  useEffect(() => {
    if (location.state?.activeServiceId) {
      setActiveId(Number(location.state.activeServiceId));
    }
    window.scrollTo(0, 0);
  }, [location.state]);

  useEffect(() => {
    if (contentRef.current) {
      const yOffset = -300;
      const y = contentRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
  }, [activeId]);

  useEffect(() => {
    if (mobileContentRef.current) {
      setTimeout(() => {
        mobileContentRef.current.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 100);
    }
  }, [mobileActiveId]);

  const selectedService = servicesData.find((s) => s.id === activeId);

  const renderDesc = (desc) => {
    const lines = desc.split("\n");
    return lines.map((line, i) => {
      const trimmed = line.trim();
      if (trimmed.length > 0 && trimmed === trimmed.toUpperCase() && !trimmed.startsWith("•") && !trimmed.startsWith("─")) {
        return <p key={i} style={{ fontWeight: "800", fontSize: "15px", color: "#0f2b46", marginTop: "24px", marginBottom: "4px", letterSpacing: "0.5px" }}>{trimmed}</p>;
      }
      if (trimmed.startsWith("─")) {
        return <div key={i} style={{ height: "2px", backgroundColor: "#0f2b46", marginBottom: "14px", marginTop: "2px" }} />;
      }
      if (trimmed.startsWith("•")) {
        return (
          <div key={i} style={{ display: "flex", gap: "10px", marginBottom: "8px", alignItems: "flex-start" }}>
            <span style={{ color: "#0f2b46", fontWeight: "900", marginTop: "2px", flexShrink: 0 }}>•</span>
            <span style={{ fontSize: "16px", lineHeight: "1.8", color: "#444" }}>{trimmed.slice(1).trim()}</span>
          </div>
        );
      }
      if (trimmed === "") return <div key={i} style={{ height: "6px" }} />;
      return <p key={i} style={{ fontSize: "16px", lineHeight: "1.9", color: "#444", marginBottom: "10px" }}>{trimmed}</p>;
    });
  };

  return (
    <div
      className="services-page"
      style={{
        padding: "90px 20px",
        background: "linear-gradient(180deg, #f4f7fa 0%, #eef2f7 100%)",
        minHeight: "100vh",
        fontFamily: "'Inter', sans-serif"
      }}
    >

      {/* HEADING */}
      <div className="services-header" style={{ textAlign: "center", marginBottom: "60px" }}>
        <h2
          style={{
            fontSize: "34px",
            fontWeight: "900",
            color: "#0f2b46",
            textTransform: "uppercase",
            marginTop: "-25px",
          }}
        >
          Our Professional Services
        </h2>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginTop: "10px" }}>
          <div style={{ width: "60px", height: "3px", backgroundColor: "#94a3b8" }}></div>
          <div style={{ width: "80px", height: "12px", backgroundColor: "#0f2b46" }}></div>
          <div style={{ width: "60px", height: "3px", backgroundColor: "#94a3b8" }}></div>
        </div>
      </div>

      {/* DESKTOP */}
      <div
        className="desktop-layout"
        style={{ display: "flex", gap: "35px", maxWidth: "1300px", margin: "0 auto" }}
      >

        {/* SIDEBAR */}
        <div style={{ flex: "0 0 420px", display: "flex", flexDirection: "column", gap: "12px" }}>
          {servicesData.map((service) => (
            <div
              key={service.id}
              onClick={() => setActiveId(service.id)}
              style={{
                padding: "18px 22px",
                cursor: "pointer",
                borderRadius: "12px",
                backgroundColor: activeId === service.id ? "#0f2b46" : "#ffffff",
                color: activeId === service.id ? "#ffffff" : "#444",
                boxShadow: activeId === service.id
                  ? "0 10px 20px rgba(15, 43, 70, 0.2)"
                  : "0 4px 12px rgba(0,0,0,0.05)",
                transition: "0.3s all ease",
                fontWeight: "700",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                border: activeId === service.id
                  ? "1px solid #0f2b46"
                  : "1px solid rgba(0,0,0,0.05)"
              }}
            >
              {service.title}
              <span>{activeId === service.id ? "●" : "›"}</span>
            </div>
          ))}
        </div>

        {/* CONTENT */}
        <div
          ref={contentRef}
          style={{
            flex: "1",
            background: "#fff",
            padding: "60px",
            borderRadius: "18px",
            boxShadow: "0 20px 50px rgba(0,0,0,0.08)"
          }}
        >
          <AnimatePresence mode="wait">
            <motion.div
              key={activeId}
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -30 }}
              transition={{ duration: 0.4 }}
            >
              <h3 style={{ fontSize: "34px", color: "#0f2b46", fontWeight: "800" }}>
                {selectedService?.title}
              </h3>

              <div
                style={{
                  width: "60px",
                  height: "5px",
                  backgroundColor: "#94a3b8",
                  borderRadius: "10px",
                  margin: "8px 0 20px"
                }}
              />

              <div>{renderDesc(selectedService?.desc || "")}</div>
            </motion.div>
          </AnimatePresence>
        </div>
      </div>

      {/* MOBILE */}
      <div className="mobile-layout" style={{ marginTop: "30px" }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          {servicesData.map((service) => (
            <div key={service.id}>

              {/* TITLE ROW */}
              <div
                style={{
                  padding: "18px 22px",
                  cursor: "pointer",
                  borderRadius: mobileActiveId === service.id ? "12px 12px 0 0" : "12px",
                  backgroundColor: mobileActiveId === service.id ? "#0f2b46" : "#fff",
                  color: mobileActiveId === service.id ? "#fff" : "#444",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                  fontWeight: "700",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: mobileActiveId === service.id
                    ? "1px solid #0f2b46"
                    : "1px solid rgba(0,0,0,0.05)"
                }}
              >
                <span>{service.title}</span>
                <span
                  onClick={() =>
                    setMobileActiveId(mobileActiveId === service.id ? null : service.id)
                  }
                  style={{ fontSize: "20px", cursor: "pointer" }}
                >
                  {mobileActiveId === service.id ? "▾" : "›"}
                </span>
              </div>

              {/* DESCRIPTION */}
              {mobileActiveId === service.id && (
                <div
                  ref={mobileContentRef}
                  style={{
                    background: "#fff",
                    padding: "20px 22px",
                    borderRadius: "0 0 12px 12px",
                    border: "1px solid #0f2b46",
                    borderTop: "none"
                  }}
                >
                  <div style={{ width: "50px", height: "4px", backgroundColor: "#94a3b8", borderRadius: "10px", marginBottom: "12px" }} />
                  <div style={{ fontSize: "14px" }}>{renderDesc(service.desc)}</div>
                </div>
              )}

            </div>
          ))}
        </div>
      </div>
    </div>
  );
}